import { SendingPlatform } from 'modules/sendingPlatforms/constants';
import styled from 'styled-components';
import { Body2, Overline, spacing, textColors } from 'ui/theme';
import { Link } from 'ui/links';
import { useMetadata } from '../../hooks';

export const Container = styled.div`
  background-color: none;
  padding: 0 ${spacing.plusQuarter};

  @media only screen and (max-width: 870px) {
    display: none;
  }
`;

export const Body2Margin = styled(Body2)`
  margin-bottom: ${spacing.plusHalf};
`;

export const OverlineMargin = styled(Overline)`
  display: block;
  margin-bottom: ${spacing.half};
  color: ${textColors.textSecondary};
`;

export const Ul = styled.ul`
  padding-left: ${spacing.plusHalf};
  & > li {
    list-style-type: disc;
    margin-bottom: ${spacing.half};
  }
`;

export const Sidebar = ({ sendingPlatform }: { sendingPlatform: SendingPlatform }) => {
  const { name, supportLink, partnerLink, editDescription } = useMetadata(sendingPlatform);

  return (
    <Container data-test="sending-platforms-details-sidebar">
      <Body2Margin>{editDescription}</Body2Margin>
      <OverlineMargin>Need help?</OverlineMargin>
      <Ul>
        {supportLink && (
          <li>
            <Link href={supportLink} target="_blank" hasOpenNewTabIcon>
              Iterable documentation
            </Link>
          </li>
        )}
        {partnerLink && (
          <li>
            <Link href={partnerLink} target="_blank" hasOpenNewTabIcon>
              {sendingPlatform === 'infobip' ? 'Meta documentation' : `${name} website`}
            </Link>
          </li>
        )}
      </Ul>
    </Container>
  );
};
